// extracted by mini-css-extract-plugin
module.exports = {"pcTableTitle":"PenaltyPaymentTable_pcTableTitle__0JC_d","spTableTitle":"PenaltyPaymentTable_spTableTitle__jZdN9"};